module.exports = __webpack_public_path__ + "img/geddan.81fdd05b.png";